module.exports = __webpack_public_path__ + "static/media/Aporbo.cef22c7e.png";